import { render } from "./InventoryRotationTab.vue?vue&type=template&id=3c1664b6"
import script from "./InventoryRotationTab.vue?vue&type=script&lang=js"
export * from "./InventoryRotationTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__